import { Box, Fade, IconButton, SvgIcon, Tooltip } from '@mui/material';
import { Close as CloseIcon, Menu as MenuIcon } from '@opengov/react-capital-assets';
import React from 'react';

import { NAV_COLOR_PALETTE } from '../../Components/styleConstants';
import { DATA_OG, DATA_TEST } from '../../enums';

interface IHamburgerMenuIconButtonProps {
  menuOpen: boolean;
  handleClick(): void;
  handleKeyDown(e: React.KeyboardEvent<HTMLElement>): void;
}

export const HamburgerMenuIconButton = React.forwardRef<HTMLButtonElement, IHamburgerMenuIconButtonProps>(
  ({ menuOpen, handleClick, handleKeyDown }, ref) => {
    return (
      <Tooltip title="Navigation">
        <IconButton
          data-test={DATA_TEST.mobile_menu_button}
          data-og={DATA_OG.mobile_menu_button}
          aria-label={menuOpen ? 'Close the navigation menu' : 'Open the navigation menu'}
          aria-haspopup="true"
          aria-expanded={menuOpen}
          disableRipple={true}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          ref={ref}
          sx={{
            p: 2.5,
            height: 24,
            position: 'relative',
            width: 24,
            borderRadius: 0.5,
            color: NAV_COLOR_PALETTE.primaryBlue,
            '&.Mui-focusVisible': {
              // Per MUI docs, Disabling ripple on focus removes all styling
              // Ensure focus style exists for accessibility
              outline: `2px solid ${NAV_COLOR_PALETTE.focus}`
            }
          }}
        >
          <Fade in={!menuOpen}>
            <Box>
              <SvgIcon
                inheritViewBox
                component={MenuIcon}
                data-test={DATA_TEST.mobile_menu_button_menu}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: NAV_COLOR_PALETTE.primaryBlue
                }}
              />
            </Box>
          </Fade>

          <Fade in={menuOpen}>
            <Box>
              <SvgIcon
                inheritViewBox
                component={CloseIcon}
                data-test={DATA_TEST.mobile_menu_button_close}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: NAV_COLOR_PALETTE.primaryBlue
                }}
              />
            </Box>
          </Fade>
        </IconButton>
      </Tooltip>
    );
  }
);
